
import ApplicationTitle from '../../../components/ApplicationTitle';
import React, { useState } from "react";
import { FaCalendar } from "react-icons/fa";
import { FaPhone } from "react-icons/fa6";
import { FaFileLines } from "react-icons/fa6";
import { InlineWidget } from "react-calendly";
import BipsyLogo from "../../../img/BipsyPay/Bipsy.png"

export default function Choices({ nextStep, nextHalfStep, handleFormData, values, validation }) {

    const [choice, setChoice] = useState(0);
    
    const handleFormClick = () => {
        setChoice(0)
    }

    const handleCallClick = () => {
        setChoice(1)
    }

    const handleScheduleClick = () => {
        setChoice(2)
    }

    const submitFormData = (e) => {

        e.preventDefault();


        // Make sure to check all validation BEFORE running this *** 
        if (values.isPrimaryContact === 'no' && values.legal === true) {
            nextHalfStep()
        }
        if (values.isPrimaryContact === 'yes' && values.legal === true) {
            nextStep()
        }
    };
    switch (choice) {
        case 0:
            return (
                <div className="bg-white-900 dark:bg-white-900 w-full">
                    <div className="items-center px-8 py-8 my-10 mx-auto w-fit py-0 text-center">
                        <div className="flex text-center justify-center mb-4 text-4xl font-bold text-black">
                            <img className="h-16" src={BipsyLogo} />
                        </div>
                        <div className="bg-white rounded-lg shadow dark:border">
                            <div className="p-6 space-y-1 sm:p-8 ">
                                <div>
                                    <div className="text-4xl mb-2 text-black font-bold">
                                        Lets active <span className="text-primary-200">this account</span>
                                    </div>
                                    <h4 className="text-xl items-center mx-auto text-black mb-6">
                                        <span className="mr-1">We need to collect some more information to get your account activated.</span>
                                    </h4>
        
                                </div>
                                <form className="space-y-4 w-4/6 mx-auto" onSubmit={submitFormData}>
                                    <div>
                                        <button type="submit" className="w-full text-white bg-primary-200 hover:bg-primary-300 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-lg px-5 py-2.5 text-center">Activate Now!</button>
                                    </div>
                                </form>
                            </div>
                        </div>
        
                        <div className="bg-white rounded-lg shadow">
                            <div className="p-6 mt-8 space-y-1 sm:p-8">
                                <h4 className="text-xl items-center text-black mb-4">
                                    Other ways contact us:
                                </h4>
                                <div className="flex flex-wrap -mx-3 mb-4">
                                    <div className="w-full md:w-1/2 px-3 mb-4 md:mb-0">
                                        <button onClick = {handleScheduleClick} class="w-full flex justify-center items-center bg-main-purple shadow rounded-lg font-medium px-5 py-2.5 text-lg"><FaCalendar/>&nbsp;Schedule a chat</button>
                                    </div>
                                    <div className="w-full md:w-1/2 px-3">
                                        <button onClick = {handleCallClick} className="w-full flex justify-center items-center bg-main-purple shadow rounded-lg px-5 py-2.5 font-medium text-lg"><FaPhone/>&nbsp;Call Now</button>
                                    </div>
                                </div>
                            </div>
                        </div>        
                    </div>
                </div>
            );
        case 1:
            return (
                <div className="bg-white-900 dark:bg-white-900 w-full">
                    <div className="items-center px-8 py-8 my-10 mx-auto w-fit py-0 text-center">
                        <div className="flex text-center justify-center mb-4 text-4xl font-bold text-black">
                            <img className="h-16" src={BipsyLogo} />
                        </div>
                        <div className="bg-white rounded-lg shadow dark:border">
                            <div className="p-6 space-y-1 sm:p-8 ">
                                <div>
                                    <div className="text-4xl mb-2 text-black font-bold mb-8">
                                        Give us <span className="text-primary-200">a call</span>
                                    </div>

                                    <div className="text-4xl mb-2 text-black font-bold mb-4">
                                        833-MYCASH7 (833.692.2747)
                                    </div>
        
                                </div>
                            </div>
                        </div>
        
                        <div className="bg-white rounded-lg shadow">
                            <div className="p-6 mt-8 space-y-1 sm:p-8">
                                <h4 className="text-xl items-center text-black mb-4">
                                    Other ways to proceed:
                                </h4>
                                <div className="flex flex-wrap -mx-3 mb-4">
                                    <div className="w-full md:w-1/2 px-3 mb-4 md:mb-0">
                                        <button onClick = {handleScheduleClick} class="w-full flex justify-center items-center bg-main-purple shadow rounded-lg font-medium px-5 py-2.5 text-lg"><FaCalendar/>&nbsp;Schedule a chat</button>
                                    </div>
                                    <div className="w-full md:w-1/2 px-3">
                                        <button onClick = {handleFormClick} className="w-full flex justify-center items-center bg-main-purple shadow rounded-lg px-5 py-2.5 font-medium text-lg"><FaFileLines />&nbsp;Complete sign-up</button>
                                    </div>
                                </div>
                            </div>
                        </div>        
                    </div>
                </div>
            );
        case 2:
            return (
                <div className="bg-white-900 dark:bg-white-900 w-full">
                    <div className="items-center px-8 py-8 my-10 mx-auto w-auto w-full py-0 text-center">
                        <div className="flex text-center justify-center mb-4 text-4xl font-bold text-black">
                            <img className="h-16" src={BipsyLogo} />
                        </div>
                        <div className="bg-white rounded-lg shadow dark:border">
                            <div className="p-6 space-y-1 sm:p-8 ">
                                <div>
                                    <div className="text-4xl mb-2 text-black font-bold mb-8">
                                        Schedule a <span className="text-primary-200">call with us</span>
                                    </div>

                                    <div className="text-4xl w-full mb-2 text-black font-bold mb-8">
                                        <InlineWidget url="https://calendly.com/support-5d4/30min?back=1&month=2024-01" />
                                    
                                    </div>
        
                                </div>
                            </div>
                        </div>
        
                        <div className="bg-white rounded-lg shadow">
                            <div className="p-6 mt-8 space-y-1 sm:p-8">
                                <h4 className="text-xl items-center text-black mb-4">
                                    Other ways to proceed:
                                </h4>
                                <div className="flex flex-wrap md:flex-nowrap lg:flex-nowrap xl:flex-nowrap 2xl:flex-nowrap -mx-3 mb-4">
                                    <div className="min-w-fit w-full md:w-1/2 px-3 mb-4 md:mb-0">
                                        <button onClick = {handleCallClick} class="w-full flex justify-center items-center bg-main-purple shadow rounded-lg font-medium px-5 py-2.5 text-lg"><FaPhone/>&nbsp;Call Now</button>
                                    </div>
                                    <div className="min-w-fit w-full md:w-1/2 px-3">
                                        <button onClick = {handleFormClick} className="w-full flex justify-center items-center bg-main-purple shadow rounded-lg px-5 py-2.5 font-medium text-lg"><FaFileLines />&nbsp;Complete sign-up</button>
                                    </div>
                                </div>
                            </div>
                        </div>        
                    </div>
                </div>
            );
    }

}